module.exports = {"340706001":"新桥街道","340706100":"五松镇","340706101":"顺安镇","340706102":"钟鸣镇","340706103":"天门镇","340706104":"东联镇","340706105":"西联镇","340706200":"老洲乡","340706203":"胥坝乡","340706401":"义安经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340706.json
// module id = 1193
// module chunks = 0